import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { UiService } from '../services/ui.service'
import { ApiService } from '../services/api.service'
import { handleArpioError } from 'src/utils/handle-error'

export interface NavigationState {
  rapidRefreshExpires: Date
  delayRapidRefresh: boolean
  forceRefreshResources?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class ApplicationFormBaseService {
  constructor(
    private router: Router,
    private uiService: UiService,
    private apiService: ApiService
  ) {}

  createNavigationState(): NavigationState {
    return {
      rapidRefreshExpires: new Date(Date.now() + 60000),
      delayRapidRefresh: true,
      forceRefreshResources: true,
    }
  }

  navigateToApplication(accountId: string, applicationId: string): void {
    const state = this.createNavigationState()
    this.router.navigateByUrl(this.uiService.buildApplicationUrl(accountId, applicationId), { state })
  }

  handleSaveError() {
    return handleArpioError(window.location.href, this.apiService, this.uiService)
  }
}
